// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/management/import-portfolio/app/css/app.css
// module id = 818
// module chunks = 0